import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import '../css/DeudasPorChofer.css'; // Puedes crear este archivo para estilos personalizados

const DeudasPorChofer = () => {
  const { chofer_id } = useParams();
  const [nombre, setNombre] = useState('');
  const [prestamos, setPrestamos] = useState([]);
  const [abonos, setAbonos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDatos = async () => {
      try {
        const [resPrestamos, resAbonos] = await Promise.all([
          axios.get(`https://deudas.transpoortessolorzano.com/prestamos/chofer/${chofer_id}`),
          axios.get(`https://deudas.transpoortessolorzano.com/abonos/chofer/${chofer_id}`)
        ]);

        if (resPrestamos.data.length > 0) {
          setNombre(resPrestamos.data[0].nombre);
        } else if (resAbonos.data.length > 0) {
          setNombre(resAbonos.data[0].nombre);
        }

        setPrestamos(resPrestamos.data);
        setAbonos(resAbonos.data);
        setLoading(false);
      } catch (error) {
        console.error('Error al cargar préstamos o abonos:', error);
        setLoading(false);
      }
    };

    fetchDatos();
  }, [chofer_id]);

  if (loading) return <div>Cargando datos...</div>;

  return (
    <div className="detalle-container">
      <h2>Detalles de Deudas de {nombre}</h2>

      <Link to="/" className="volver-link">← Volver al resumen</Link>

      <div className="seccion">
        <h3>Préstamos</h3>
        {prestamos.length === 0 ? (
          <p>No hay préstamos registrados.</p>
        ) : (
          <table className="detalle-tabla">
            <thead>
              <tr>
                <th>Fecha</th>
                <th>Cantidad</th>
                <th>Motivo</th>
                <th>Firma</th>
              </tr>
            </thead>
            <tbody>
              {prestamos.map((p) => (
                <tr key={p.id}>
                  <td>{new Date(p.fecha).toLocaleString('es-MX')}</td>
                  <td>${parseFloat(p.cantidad).toFixed(2)}</td>
                  <td>{p.descripcion}</td>
                  <td>
                    {p.firma ? (
                      <img
                        src={p.firma}
                        alt="Firma préstamo"
                        className="firma-imagen"
                      />
                    ) : (
                      'Sin firma'
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      <div className="seccion">
        <h3>Abonos</h3>
        {abonos.length === 0 ? (
          <p>No hay abonos registrados.</p>
        ) : (
          <table className="detalle-tabla">
            <thead>
              <tr>
                <th>Fecha</th>
                <th>Cantidad</th>
                <th>Motivo</th>
                <th>Firma</th>
              </tr>
            </thead>
            <tbody>
              {abonos.map((a) => (
                <tr key={a.id}>
                  <td>{new Date(a.fecha).toLocaleString('es-MX')}</td>
                  <td>${parseFloat(a.cantidad).toFixed(2)}</td>
                  <td>{a.descripcion}</td>
                  <td>
                    {a.firma ? (
                      <img
                        src={a.firma}
                        alt="Firma abono"
                        className="firma-imagen"
                      />
                    ) : (
                      'Sin firma'
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default DeudasPorChofer;
